import React, { useEffect, useState } from "react";
import { t } from "../../utils/i18n";
import { IconUserPurple } from "./dashboardIcons";
import { getRequest } from "../../utils/httpRequest";

const FeaturedTraders = ({ currency }) => {
  useEffect(async () => {
    getRequest(`/api/v1/p2p_trades/featured_traders?currency=${currency}`).then(
      (response) => {
        console.log("Featured Traders Response:", response);
        setFeaturedTradersData(response);
      }
    );
  }, [currency]);

  const [featuredTradersData, setFeaturedTradersData] = useState([]);

  console.log("Featured Traders Data:", featuredTradersData);
  return (
    <div id="featured-traders" className="tabcontent">
      <div className="traders">
        {featuredTradersData?.map((trader, index) => (
          <div className="trader" key={index}>
            <div
              className="profile"
              onClick={() =>
                (window.location.href = trader.trader_profile_link)
              }
            >
              <IconUserPurple />
              <div className="profile-name">
                <a href={trader.trader_profile_link}>
                  <h4 className="profile-username">{trader.trader_label}</h4>
                </a>
                <h5 className="profile-payments">
                  {trader.trader_payment_method}
                </h5>
                <div className="profile-location d-flex">
                  <i
                    className="fa fa-globe profile-location-icon"
                    aria-hidden="true"
                  ></i>
                  <h6>{trader.trader_location}</h6>
                </div>
                <div className="profile-location d-flex">
                  <span>{t("dashboard.featured.volume")}</span>
                  <h6>{trader.trader_trade_vol}</h6>
                </div>
              </div>
            </div>
            <a
              className="details"
              href={`/p2p_trades/offers/search?offer_type=buy&selected_trader=${trader.trader_label}`}
            >
              {t("dashboard.featured.trade")}
            </a>
          </div>
        ))}
        {featuredTradersData.length === 0 && (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <p className="text-center w-100 my-5">
              {t("dashboard.featured.none")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturedTraders;
